import HorizonTopicsModule from '@/modules/horizon/topics';
import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { AccessDenied } from '@/components/ui/access-denied';
import { useAccessControl } from '@/hooks/useAccessControl';
/**
 * URL search params for the Topics list page.
 * List filters are optional; sheet/dialog params appear only when a sheet or dialog is open.
 */
const searchSchema = z.object({
  section: z.enum(['PUBLISHED', 'UNPUBLISHED']).default('PUBLISHED'),
  publishedTab: z
    .enum(['ACTIVE', 'UPCOMING', 'PAUSED', 'SETTLED'])
    .default('ACTIVE'),
  unpublishedTab: z.enum(['UPCOMING', 'LIVE']).default('UPCOMING'),
  cursor: z.string().optional(),
  page: z.coerce.number().default(1),
  limit: z.coerce.number().default(12),
  search: z.string().optional(),
  categoryId: z.string().optional(),
  sheet: z.enum(['create', 'edit']).optional(),
  id: z.string().optional(),
  liveBadge: z.string().optional(),
  pause: z.string().optional(),
  resume: z.string().optional(),
  expire: z.string().optional(),
});

export const Route = createFileRoute('/dashboard/horizon/topics/')({
  validateSearch: searchSchema,
  component: HorizonTopicsPage,
});

function HorizonTopicsPage() {
  const { canAccessHorizonTopics } = useAccessControl();
  if (!canAccessHorizonTopics) {
    return <AccessDenied />;
  }
  return <HorizonTopicsModule />;
}
